export const GAS_ENERGY_COST_ID = 'gas';
export const EV_ENERGY_COST_ID = 'ev';
export const HOME_ENERGY_COST_ID = 'home';

export const HOME_ENERGY_CHART_COLOR = '#F15C22';
export const EV_ENERGY_CHART_COLOR = '#1A7789';
export const GAS_ENERGY_CHART_COLOR = '#635550';
